import CardRecipients from "@/components/dashboard/modal/CardRecipients";
import RecipientsMain from "@/components/dashboard/recipients/RecipientsMain";

export default function Recipients() {
  return (
    <>
      {/* Card Recipients */}
      <CardRecipients />

      {/* Recipients Main */}
      <RecipientsMain />
    </>
  );
}
